import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss']
})
export class TableSkeletonComponent implements OnInit {

  @Input() rows: number;
  @Input() height: string;
  @Input() striped: boolean;

  constructor() {
    this.rows = 8;
    this.height = '';
    this.striped = false;
  }

  ngOnInit(): void {
  }

}
